import { getRetailAd } from './getRetailAd';
import { postRetailAdDisplayEvent } from './postRetailAdDisplayEvent';

export const retailAdService = {
  getRetailAd,
  postRetailAdDisplayEvent,
};
